import { Main } from './main.js'
import ReactDOM from 'react-dom/client'

const root = document.getElementById('root')
if (!root) throw new Error('root element not found')

ReactDOM.createRoot(root).render(<Main />)
